import React, { type FunctionComponent } from 'react'
import type { FormField } from './Form'

type Props = {
  fields: FormField[]
  values: { [key: string]: any }
  displayValueMap: { [key: string]: string }
}

export const SectionData: FunctionComponent<Props> = ({ fields, values, displayValueMap }) => {
  return (
    <>
      {fields.map(field => {
        const value = values[field.name]

        const display =
          field.type === 'date' ? new Date(value).toLocaleDateString() : displayValueMap[value] || value || ' - '
        const displayFinal = field.options && field.options[value] ? field.options[value] : display

        return (
          <dl className="mb-lg" key={`field-${field.name}`}>
            <dt className="mb-sm text-storm" id={`data-${field.name}`}>
              {field.label}
            </dt>
            <dd className="break-all" aria-labelledby={`data-${field.name}`}>
              {displayFinal}
            </dd>
          </dl>
        )
      })}
    </>
  )
}
